import * as Yup from 'yup';

export const email = Yup.string()
  .strict()
  .trim('Please remove spaces before and after email')
  .email('Email is not valid')
  .max(50, 'Email should be less than 50 symbols')
  .required('Email is required');
